import { eventKeyConstants } from './eventKey';

export const navListHelper = (event: any, parentId: any, menuClass: any) => {
    const refElem = document.getElementById(parentId);
    const menuItems = refElem.querySelectorAll(menuClass);
    let currIndex: any = getCurrIndex(menuItems);
    let currItem: any = menuItems[currIndex];

    switch (event.key) {
        case eventKeyConstants.ARROWRIGHT:
            event.preventDefault();
            if (currItem == menuItems[menuItems.length - 1]) {
                currItem = menuItems[0];
                currIndex = 0;
            }
            else {
                const nextIndex = currIndex + 1;
                currItem = menuItems[nextIndex];
            }
            currItem.focus();
            break;
        case eventKeyConstants.ARROWLEFT:
            event.preventDefault();
            if (currItem == menuItems[0]) {
                currItem = menuItems[menuItems.length - 1];
                currIndex = menuItems.length - 1;
            }
            else {
                const prevIndex = currIndex - 1;
                currItem = menuItems[prevIndex];
            }
            currItem.focus();
            break;
        case eventKeyConstants.HOME:
            event.preventDefault();
            (menuItems[0] as HTMLElement).focus();
            break;
        case eventKeyConstants.END:
            event.preventDefault();
            (menuItems[menuItems.length - 1] as HTMLElement).focus();
            break;
        default:
            break;
    }
}
const getCurrIndex = (menuItems) => {
    let currIndex = 0;
    menuItems.forEach((el, index) => {
        if (el == document.activeElement) {
            currIndex = index;
        }
    })
    return currIndex;
}

